import { useQuery } from '@tanstack/react-query'

import { getSISContract } from '~/contracts/getSISContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'
import { useVESISParams } from './useVESISParams'

export function useGetSISTokenBalance() {
	const { config, provider } = useVESISParams()

	const { account } = useWallet()

	return useQuery({
		queryKey: sisTokenKeys.balance(config.chain.id, account),
		queryFn: () => {
			const contract = getSISContract(config, provider)

			return contract.balanceOf(account)
		},
		enabled: !!account,
	})
}
